module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("czTNJ"))).then(() => parcelRequire('ljYL6'));